
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gfK0RXV7_n7_Gz3m6Yu0czlkpzb75XNk_D_xFto_zgwYMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexoSWBRJIBUCcBfdvPqUv4mtxmzLcPP8ohBJnZsQnTMS8Meta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchTEJTwMv13NHPm_45e0v_45vqeO_45SyBZkBSuYux1Ipb5OmosMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexjNEy9UWuTWuTIZXE7y9IRpD7qXQY7XUVuZJbQEvtlJcMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93XZsxfGW_QWCzrhIG9BWTBIEzg_mvcBFmQ4xmLbeRzB0Meta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexg5L5_3znY2SpoRq_45zplBGkgVkJV8MwYZpv9vD0N8UoQMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93nhDcx7AxskGwVbza7OAmOU9fq0_3WwXsRdmyXS0JNbwMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexZckGTtjrSSYb0w5fVrBsMjaP899BYcbk5gzzMNl_45YO8Meta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93sq6o3LF7Bp24ANM1R8qIcKwTJDGCgjSMq3pYPREyWUsMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexuwElVxvr7wNhhT5zXAzqhoaUPIgkeVFk_45BA4u8A2wfgMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexcvEsPX_SFBhlWCz_45swB3WIkd1PyYo2YZguMnNqeNfKsMeta } from "/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexg5L5_3znY2SpoRq_45zplBGkgVkJV8MwYZpv9vD0N8UoQMeta || {},
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexZckGTtjrSSYb0w5fVrBsMjaP899BYcbk5gzzMNl_45YO8Meta || {},
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexuwElVxvr7wNhhT5zXAzqhoaUPIgkeVFk_45BA4u8A2wfgMeta || {},
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexcvEsPX_SFBhlWCz_45swB3WIkd1PyYo2YZguMnNqeNfKsMeta || {},
    component: () => import("/codebuild/output/src325727776/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]